import { useState } from 'react';
import { Chip, Stack } from '@mui/material';
import { CourseTypesEditDialog } from './course-types-edit-dialog';
import { courseTypesLabels } from '@/constants/catalog/course';
import { useRecommendationProfile } from '@/context/recommendation-profile';
import { CourseTypes as CourseTypesEnum } from '@/models/catalog/course';
import { ProfileItem } from '@/packages/my-profile/components/profile-item';

export const CourseTypes = () => {
  const { profile, updateProfile } = useRecommendationProfile();

  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleSave = (courseTypes: CourseTypesEnum[]) => {
    updateProfile({ profile: { ...profile, course_types: courseTypes } });
    setIsDialogOpen(false);
  };

  const hasCourseTypes =
    profile?.course_types && profile?.course_types?.length > 0;

  return (
    <>
      <ProfileItem
        title="Tipos de cursos"
        onClick={() => setIsDialogOpen(true)}
      >
        {hasCourseTypes && (
          <Stack direction="row" gap={2} flexWrap="wrap">
            {profile?.course_types?.map((courseType: CourseTypesEnum) => (
              <Chip key={courseType} label={courseTypesLabels[courseType]} />
            ))}
          </Stack>
        )}
      </ProfileItem>
      {isDialogOpen && (
        <CourseTypesEditDialog
          currentValues={profile?.course_types ?? []}
          onClose={() => setIsDialogOpen(false)}
          onSave={handleSave}
        />
      )}
    </>
  );
};
